<template>
    <div id="image-uploader" class="row">
        <div class="col-lg-12" v-if="!image">
            <h2>{{ placeholder ? placeholder : 'Kép' }}</h2>
            <input type="file" ref="file" accept="image/*" @change="onFileChange">
        </div>
        <div class="col-lg-12" v-else>
            <div class="row">
                <div class="col-lg-10">
                    <img :src="image" />
                    <button class="btn btn-sm btn-secondary" @click="removeImage">Kép eltávolítása {{ info }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'image-uploader',
        props: ['data', 'placeholder'],
        data() {
            return {
                image: '',
                info: '',
                imageObject: {}
            }
        },
        methods: {
            onFileChange(e) {
                var files = e.target.files || e.dataTransfer.files;
                if (!files.length)
                    return;
                this.createImage(files[0]);
            },
            createImage(file) {
                var reader = new FileReader();
                var vm = this;

                reader.onload = (e) => {
                    vm.image = e.target.result;

                    let img = new Image();
                    img.src = vm.image;

                    vm.imageObject.data = vm.image;

                    img.onload = function() {
                        vm.info = '('+this.width +'x' + this.height+')';

                        vm.imageObject.filename = file.name,
                        vm.imageObject.type = file.type,
                        vm.imageObject.dimensions = {
                            width: this.width,
                            height: this.height,
                        }

                        vm.$emit('onImageLoaded', vm.imageObject);
                        vm.$emit('onImageChanged', vm.imageObject);
                    };
                };

                reader.readAsDataURL(file);
            },
            removeImage: function (e) {
                this.image = '';
                this.$emit('onImageRemoved');
            }
        },
        mounted() {
            this.image = this.data && this.data.image ? this.data.image : '';
        } ,
        watch: {
            data: function(newVal) {
                if(newVal) {
                    this.image = newVal.image;

                    if(newVal.dimensions) {
                        this.info = '('+newVal.dimensions.width+'x'+newVal.dimensions.height+')';
                    }
                } else {
                    this.image = '';
                }
            }
        }
    }
</script>

<style scoped>
    img {
        width: 100%;
        margin: auto;
        display: block;
        margin-bottom: 10px;
    }
</style>